<!-- eslint-disable max-lines -->
<template>
    <Paper class="bill-detail finance-detail">
        <div class="contents" v-loading="loading">
            <div class="buttons">
                <el-button @click="goLists" v-has="'07050001'">返 回</el-button>
                <el-button type="primary" :disabled="isSave" v-has="'07050002'" @click="confirmOk">保存</el-button>
                <el-upload
                    v-if="!isSmartInvoice"
                    style="display: inline; margin:0 10px"
                    action="'image/*'"
                    :disabled="isUpdate"
                    accept=".svgz,.pjp,.jfif,.ico,.tiff,.svg,.xbm,.pjpeg,.webp,.tif,.jpeg,.png,.gif,.bmp,.pdf,.jpg"
                    :before-upload="checkDataInfo"
                    :http-request="submitUpload"
                    multiple :show-file-list="false">
                    <el-button size="small" type="primary" :disabled="isUpdate" v-has="'07050003'" style="padding: 7px 15px">上传发票</el-button>
                </el-upload>
                <el-upload
                    style="display: inline; margin:0 10px"
                    action="'image/*'"
                    :disabled="isUpdate"
                    accept=".svgz,.pjp,.jfif,.ico,.tiff,.svg,.xbm,.pjpeg,.webp,.tif,.jpeg,.png,.gif,.bmp,.pdf,.jpg"
                    :http-request="submitSalesUpload"
                    multiple :show-file-list="false">
                    <el-button size="small" type="primary" v-has="'07050004'" :disabled="isUpdate" style="padding: 7px 15px">上传销货清单</el-button>
                </el-upload>
                <el-button type="primary" :disabled="genInvoiceDisabled" v-if="isSmartInvoice" v-has="'07050008'" @click="handleGenerateInvoice">生成/关联发票</el-button>
                <el-button type="primary" :disabled="isSend"  v-if="!isSmartInvoice" v-has="'07050005'" @click="outloadInvoice">发票寄出</el-button>
                <el-button type="primary" :disabled="isSubmit" v-has="'07050006'" @click="submitApply">提交付款</el-button>
                <el-button type="primary" :disabled="isCancell" v-has="'07050007'" @click="cancellClick">作废</el-button>
                <el-button type="primary" :disabled="advanceCollectionDisabled" v-has="'07050009'" :loading="advanceCollectionBtnLoading" @click="handelAdvanceCollection">申请提前收款</el-button>
            </div>
            <div class="line"></div>
            <div class="head-content">
                <div class="head-title settle-detail-header">
                    <div class="head-t">
                        <h3 class="head-h3">
                            申请单号：{{ currObject.apApplyNo }}
                        </h3>
                        <span class="bill-head-status" style="margin: 12px 5px;margin-left: 10px">{{ statusName }}</span>
                        <span class="bill-head-status" style="margin: 12px 5px">{{ payStatusName }}</span>
                        <span class="bill-head-status" style="margin: 12px 5px">{{ invoiceStatusName }}</span>
                        <div v-if="isSmartInvoice" class="head-cautions">
                            <div>操作注意事项：</div>
                            <div>第一步：填写备注信息，点“保存”按钮</div>
                            <div>第二步：点击“生成发票”，根据需要选择对应的开票方式。</div>
                            <div>第三步：预生成发票后检查发票信息，确认无误后，首先确认24小时内登陆过智汇票系统，确认完毕后，点击“信息确认”并生成发票，并等待系统开票后回传信息。</div>
                            <div>第四步：发票全部开具成功后，对应开票状态变更为“已开票”，待系统付款申请的发票状态变更为“全部上传”后，可等待系统自动提交付款申请，也可以手动点击“提交付款”。</div>
                        </div>
                        <div v-else class="head-cautions">
                            <div>操作注意事项：</div>
                            <div>第一步：填写备注信息，点“保存”按钮</div>
                            <div>
                                第二步：上传发票（1、请检查上传识别后的发票信息是否与纸质发票一致；是否验真成功；2、发票是否按安得要求开具；3、发票是否盖发票章；4、如果发票上货物或应税劳务、服务名称为“详见销货清单”的，请务必在下方“附件详情”中上传发票清单；
                                ）</div>
                            <div>第三步：发票寄出（1、发票全部上传后，再邮寄安得总部；2、请按安得要求折叠发票及清单；3、按邮寄信息填写正确的快递单号；4、如为电子发票，无需邮寄，点“发票寄出”即可；）
                            </div>
                            <div>第四步：提交付款，操作完发票寄出后，请一定要点“提交付款”才算完成所有操作。</div>
                        </div>
                    </div>
                    <el-button class="head-btn" @click="isShowThree = !isShowThree">{{
                    this.isShowThree ? "收起" : "展开"
                    }}</el-button>
                </div>
                <div class="list-title">收款信息</div>
                <el-collapse-transition>
                    <div v-show="isShowThree" class="head">
                        <GatherInfo ref="apApplyObject" :apApplyObject=currObject :invoiceUpAmt=invoiceUpAmt
                            :cancelAmt=cancelAmt :preAmt=preAmt :accInvoiceAmt=accInvoiceAmt @remarkStatuSave=remarkStatuSave
                            :isSave=isSave :taxRateData=taxRateData></GatherInfo>
                    </div>
                </el-collapse-transition>
            </div>
            <div class="head-content head-bill">
                <div class="bill-title">
                    <div>
                        银行信息
                    </div>
                    <div>
                        <el-button class="head-btn" @click="isShowOne = !isShowOne">{{
                        this.isShowOne ? "收起" : "展开"
                        }}</el-button>
                    </div>
                </div>
                <div class=" bill-concnet">
                    <div>
                        <el-collapse-transition>
                            <div v-show="isShowOne" class="head">
                            <BillInfo ref="billInfo"
                                :apApply = currObject
                                :isSave = isSave
                                @updateBank="updateBank"/>
                            </div>
                        </el-collapse-transition>
                    </div>
                </div>
            </div>
            <div class="head-content">
                <div>邮寄信息</div>
                <el-collapse-transition>
                    <div v-show="isShowThree" class="head">
                        <MailInfo :apApply=currObject />
                    </div>
                </el-collapse-transition>
            </div>
            <div class="steps">
                <speed :process="process"></speed>
            </div>
            <el-tabs v-model="activeName">
                <el-tab-pane label="账单信息" name="first">
                    <Bill-detail :tableDataLists = billheaderList :tableDataItems="tableDataItems"></Bill-detail>
                </el-tab-pane>
                <el-tab-pane label="发票登记" name="second">
                    <div class="add-invoice-btn">
                        <el-button v-if="!isSmartInvoice" class="add-invoice-ico" :disabled="isUpdate"  @click="addInvoiceHandler">
                            <i class="icon el-icon-plus"></i>
                            <span class="research-label">新增</span>
                        </el-button>
                    </div>
                    <Invoice ref="invoiceRegister" :v-loading="isInvoLoad" :invoiceStatus="invoiceStatus" :isSmartInvoice="isSmartInvoice" :status="status"  :invoiceLists="invoiceLists"
                        :invoiceItems="invoiceItems" :isInvose="isInvose" :manualFlag="manualFlag" @cellClick="deleteInvoice"
                        @previewClick="previewClick" @redOffset="handleRedOffset" @reopen="handleReopen">
                    </Invoice>
                </el-tab-pane>
                <el-tab-pane label="网点信息" name="three">
                    <Network-info :networkInfoLists="networkInfoLists" :networkInfoItems="networkInfoItems">
                    </Network-info>
                </el-tab-pane>
                <el-tab-pane label="合同信息" name="four">
                    <Writeoff-item :tableDataLists="contractDataList" :tableDataItems="contractInfoItems">
                    </Writeoff-item>
                </el-tab-pane>
                <el-tab-pane label="附件详情" name="five">
                    <AccessoryDetail :v-loading="isInvoLoad" :businessId="this.currObject.jobId"
                        :accessoryList="accessoryList" :accessoryItems="accessoryItems" :annexesFlag="annexesFlag"
                        @updateAnnexesList="updateAnnexesList">
                    </AccessoryDetail>
                </el-tab-pane>
                <el-tab-pane label="申请提前收款" name="six">
                    <AdvanceCollection ref="advanceCollectionRef" :apApplyNo="currObject.apApplyNo" :jobId="currObject.jobId" @abandonSuccess="refreshInvoice" @resData="handelAdvCollResData">
                    </AdvanceCollection>
                </el-tab-pane>
            </el-tabs>
            <!-- 发票上传 -->
            <InvoiceListDialog
                v-if="dialogVisible"
                ref="dialogVisible"
                :dataRow="dataRow"
                :title="title"
                :requestParam = "requestParam"
                :dialogVisible.sync="dialogVisible"
                :apApplyObj = "currObject"
                :invoiceLists ="invoiceUplodList"
                :refreshInvoice = "refreshInvoice"
                @clearCacheData="clearCacheDataMall"
            >
            </InvoiceListDialog>
            <!-- 发票寄出 弹框 -->
            <MallDialog v-if="MalldialogVisible" ref="MalldialogVisible" :dataRow="dataRow" :title="title"
                :dialogVisible.sync="MalldialogVisible" @cancelDialog="cancelDialogMall" @saveFrom="updateCourier"
                :apApply=currObject>
            </MallDialog>
            <Picture v-if="diaShaow" :data="rowData" :titlePicture="titlePicture" :imgUrl="imgUrl" :diaShaow="diaShaow"
                @handleStartClose="handleStartClose"></Picture>
            <AddInvoiceDialog
                v-if="addDialogVisible"
                ref="addDialogVisible"
                :addDialogVisible.sync="addDialogVisible"
                @closeAddDialog="closeAddDialog"
                @refreshInvoice="refreshInvoice"
                :invoiceLists ="invoiceUplodList"
                :apApplyObj = "currObject"
            ></AddInvoiceDialog>

            <!-- 提前收款申请 -->
            <AdvanceCollectionDialog
                v-if="!advanceCollectionDisabled"
                ref="advanceCollectionDialog"
                @finalizationSuccess="refreshInvoice"
            ></AdvanceCollectionDialog>

            <!-- 选择发票标签弹窗 -->
            <invoice-label-dialog title="请选择发票标签" :loading="invoiceLabelDialogLoading" :open-dialog.sync="selectInvoiceLabelDialog" @afterConfirm="handleInvoLabelConfirm"></invoice-label-dialog>

            <!-- 未关联到结算申请单的发票 -->
            <MyMultiSelectTableDialog
                v-if="openNoAssoInvoiceDialog"
                :tableList="noAssApplNoInvoiceList"
                ref="openNoAssoInvoiceDialog"
                :config="noAssoInvoiceDialogConfig"
                :advanceCheckedList="assoInvoiceCheckedList"
                @closeDialog="openNoAssoInvoiceDialog = false"
                @confirmDialog="confirmNoAssoInvoiceDialog">
            </MyMultiSelectTableDialog>

            <!-- 关联了智汇票开票的发票 -->
            <MyMultiSelectTableDialog
                v-if="openAssoSmartInvoiceDialog"
                :tableList="invoiceLists"
                :config="AssoSmartInvoiceDialogConfig"
                ref="openAssoInvoiceDialog"
                :advanceCheckedList="assoSmartInvoiceCheckedList"
                @closeDialog="openAssoSmartInvoiceDialog = false"
                @confirmDialog="confirmAssoSmartInvoiceDialog">
            </MyMultiSelectTableDialog>

            <!-- 开票方式选择弹窗 -->
            <OpenInvoiceTypeDialog :title="openInvoiceTypeTitle" :loading="openInvoiceTypegLoading" :open-dialog.sync="openInvoiceTypeDialog" @afterConfirm="handleOpenInvoiceTypeConfirm">
            </OpenInvoiceTypeDialog>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import GatherInfo from './components/GatherInfo';
import BillDetail from './components/BillDetail';
import WriteoffItem from './components/WriteoffItem';
import Invoice from './components/Invoice';
import NetworkInfo from './components/NetworkInfo';
import Picture from '../../../components/dialog/Picture';
import speed from '../../../components/speed/speed';
import data from './components/index.js';
import mixin from './settleDetailsMixin';
import BillInfo from './components/BillInfo';
import MailInfo from './components/MailInfo';
import MallDialog from './dialog/MallDialog';
import AccessoryDetail from './components/AccessoryDetail';
import InvoiceListDialog from '@/modules/transport/bms/components/dialog/InvoiceListDialog';
import AddInvoiceDialog from './dialog/AddInvoiceDialog';
import InvoiceLabelDialog from '@/modules/transport/bms/views/finance/invoiceManage/components/InvoiceLabelDialog.vue';
// import advanceDialog from '@/components/lots/otpAdvanceDialog';
import MyMultiSelectTableDialog from '@/modules/transport/bms/components/dialog/multiSelectTableDialog/my.vue';
import AdvanceCollectionDialog from './dialog/AdvanceCollectionDialog.vue';
import AdvanceCollection from './components/AdvanceCollection.vue';
import OpenInvoiceTypeDialog from './components/OpenInvoiceTypeDialog.vue';
import { getSuContract, feeApBillQuery, getFillLists, getInvoiceOperation, getNetworkInfos, getApApplyListApDetail } from '../../../api/billDetails';
import {
    getSettleDetailLists,
    recallApply,
    saveApply,
    submitApply,
    deleteInvoice,
    invoiceOperation,
    getAccessoryList,
    getVisualization, paymentCheck, paymentSubmit, querySysParam,
    generateInvoicePreDeal,
    genExtsysInvoice,
    reissueInvoice,
    redFlushInvoice,
    relateInfoOfExtsysInvoice,
    uploadAndSaveInvoice,
    cancelApplyE,
    checkApplySupIsEqualOpenInvoiceCompany
} from '@/modules/transport/bms/api/settleDetails.js';
import common from '../../../common/common';
const { initSessionData } = common;
const INVOICE_OT = 'OT';
const INVOICE_NO_UPLOAD = ['10', 10];
const INVOICE_PARTIAL_UPLOAD = ['20', 20];
export default {
    name: 'settleDetails',
    components: { Paper,
        BillInfo,
        MailInfo,
        GatherInfo,
        BillDetail,
        WriteoffItem,
        Invoice,
        NetworkInfo,
        Picture,
        MallDialog,
        speed,
        AccessoryDetail,
        InvoiceListDialog,
        InvoiceLabelDialog,
        MyMultiSelectTableDialog,
        AddInvoiceDialog,
        AdvanceCollection,
        AdvanceCollectionDialog,
        OpenInvoiceTypeDialog
    },
    mixins: [mixin],
    data() {
        return {
            invoiceLabelDialogLoading: false,
            remarkOK: false,
            isShowOne: true,
            isShowTwo: true,
            isShowThree: true,
            isSave: true,
            isUpdate: true,
            isSend: true,
            isSubmit: true,
            isRecall: true,
            isCancell: true,
            MalldialogVisible: false,
            addDialogVisible: false,
            isInvose: false,
            currObject: {},
            invoiceUpAmt: 0,
            billheaderList: [],
            contractDataList: [],
            cancelAmt: 0.0,
            accInvoiceAmt: 0,
            preAmt: 0,
            payStatusName: '',
            statusName: '',
            invoiceStatus: '',
            invoiceStatusName: '',
            isSaveChild: true,
            accessoryList: [],
            annexesFlag: true,
            invoiceUplodList: [],
            advanceCollectionBtnLoading: true,
            advCollChangeStatusName: '',
            isSystemParamIncludeFiliale: false,
            requestParam: undefined,
            openNoAssoInvoiceDialog: false,
            noAssoInvoiceDialogConfig: {
                title: '选择发票',
                tooltip: ['sysInvoiceNo', 'createTime'],
                rowKeyProp: 'sysInvoiceNo',
                table: [
                    { prop: 'sysInvoiceNo', label: '发票号', width: '90px' },
                    { prop: 'createTime', label: '开票日期', width: '90px' },
                    { prop: 'amt', label: '价税合计金额', width: '90px' }
                ]
            },
            assoInvoiceCheckedList: [],
            saveButLoad: false,
            selectInvoiceLabelDialog: false,
            invoiceLabelForm: {
                invoiceLabel: ''
            },
            isSmartInvoice: false, // 智慧票开票标识
            manualFlag: false, // 手工关联标识
            openAssoSmartInvoiceDialog: false,
            AssoSmartInvoiceDialogConfig: {
                title: '选择发票红冲',
                tooltip: ['invoiceSerial', 'invoiceTypeName'],
                rowKeyProp: 'invoiceSerial',
                table: [
                    { prop: 'invoiceSerial', label: '发票号码', width: '90px' },
                    { prop: 'invoiceTypeName', label: '发票类型', width: '90px' },
                    { prop: 'amt', label: '发票金额', width: '90px' }
                ]
            },
            assoSmartInvoiceCheckedList: [],
            noAssApplNoInvoiceList: [],
            openInvoiceTypegLoading: false,
            openInvoiceTypeDialog: false,
            openInvoiceTypeTitle: '',
            genExtsysInvoiceExecuteFn: null
        };
    },
    computed: {
        // 是否保理业务
        isApService: function() {
            return [1, '1'].includes(this.currObject.isApService);
        },
        // 流程步骤最后的索引
        PROCESS_LAST_STEP: function() {
            return [1, '1'].includes(this.currObject.isApService) ? 7 : 5;
        },
        advanceCollectionDisabled: function () {
            /**
             * description 申请提前收款按钮-可操作
             *  1.付款申请单应付账款服务为否(0)；
             *  2.付款申请单记账状态为“记账成功(30)”；
             *  3.付款申请单付款状态非“已付款”（未付款(10)或部分付款(30)）；
             *  4.付款申请废弃时
             *  5.系统控制参数“直融宝上线分公司”，分公司在该参数范围内；
             */
            const isApService = [0, '0'].includes(this.currObject.isApService);
            const accountStatus = [30, '30'].includes(this.currObject.accountStatus);
            const isNoPay = [10, '10', 30, '30'].includes(this.currObject.payStatus);
            // const isAbandon = [99, '99'].includes(this.advCollChangeStatusName) || this.advCollChangeStatusName === '';
            const usable = isApService && accountStatus && isNoPay && this.isSystemParamIncludeFiliale;
            return !usable;
        },
        // 生成发票disabled
        genInvoiceDisabled: function() {
            // “智汇票开票”标识为是，发票状态为未上传或部分上传;作废状态，置灰生成发票按钮
            return !(this.isSmartInvoice && [10, 20].includes(this.currObject.invoiceStatus)) || [80, '80'].includes(this.currObject.status);
        }
    },
    methods: {
        /**
         * description 生成发票前的校验
         */
        generateInvoiceCheck(callback) {
            let isHasNoAss = false; // 是否存在未关联到结算申请单的发票
            let isCurApApplyNoHasGenerateInvoice = false; // 是否当前结算申请单已生成发票
            generateInvoicePreDeal({ jobId: this.currObject.jobId }).then((res) => {
                if (res && +res.code === 0) {
                    const resData = res.data || [];
                    this.noAssApplNoInvoiceList = resData.filter((item) => {
                        // 是否已存在当前结算申请单号的发票,并且"是否同步结算申请"不为是
                        if (!isCurApApplyNoHasGenerateInvoice && item.apApplyNo === this.currObject.apApplyNo && item.hasSynchApply === 0) {
                            isCurApApplyNoHasGenerateInvoice = true;
                        }
                        // 是否存在结算申请单号为空、是否同步结算申请为空的发票
                        return !item.apApplyNo && !item.hasSynchApply;
                    });
                    isHasNoAss = !!this.noAssApplNoInvoiceList.length;
                    callback && callback(isHasNoAss, isCurApApplyNoHasGenerateInvoice);
                    return isHasNoAss;
                }
            });
        },

        // 生成发票
        handleGenerateInvoice() {
            const isNoUpload = INVOICE_NO_UPLOAD.includes(this.currObject.invoiceStatus); // 发票是否未上传
            const isPartialload = INVOICE_PARTIAL_UPLOAD.includes(this.currObject.invoiceStatus); // 发票是否部分上传
            if (this.remarkOK) return this.$message.warning('请先录入备注并确认单据信息，保存成功后再生成发票。');
            const openConfirmNewInvoiceMsgBox = () => this.openMsgConfirmbox('该结算申请已上传部分发票，请确认是否开具新发票？').then(() => {
                // 打开选择发票标签
                this.selectInvoiceLabelDialog = true;
            });
            this.generateInvoiceCheck((isHasNoAss, isCurApApplyNoHasGenerateInvoice) => {
                if (isCurApApplyNoHasGenerateInvoice) {
                    this.$msgbox({
                        title: '提示',
                        message: '当前结算申请单已生成发票，请在【发票管理】查询发票并完成提交开票。',
                        type: 'info',
                        showCancelButton: false
                    });
                } else if ((isNoUpload || isPartialload) && isHasNoAss) { // 存在未关联到结算申请单的发票
                    this.openMsgConfirmbox('存在未关联到结算申请单的发票，是否直接上传？').then(() => {
                    // 打开选择未关联到结算申请单的发票弹窗
                        this.openNoAssoInvoiceDialog = true;
                    }).catch(() => {
                        if (isNoUpload) {
                            // 去生成发票
                            this.goGenerateInvoice();
                        } else if (isPartialload) {
                            openConfirmNewInvoiceMsgBox();
                        }
                    });
                } else if (isPartialload && !isHasNoAss) {
                    openConfirmNewInvoiceMsgBox();
                } else {
                    this.goGenerateInvoice();
                }
            });
        },
        // 去发票管理详情生产发票
        goGenerateInvoice(flag = true, invoiceLabel) {
            const toParams = JSON.stringify({
                invoiceLabel: invoiceLabel || '10',
                makeInvoiceStatus: '10',
                ...this.currObject
            });
            const toQuery = { hasInvoice: false, source: 'settleDetails' };
            const toFn = () => {
                this.$msgbox({
                    title: '提示',
                    message: '自动生成的开票内容供参考，若信息有误可自行调整。',
                    type: 'info',
                    showCancelButton: false,
                    showClose: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    confirmButtonText: '关闭'
                });
                this.$router.push({
                    name: `InvoiceManageDetails`,
                    params: { apApplyData: toParams },
                    query: toQuery
                });
            };
            if (flag) {
                const genExtsysInvoiceFn = ({ openInvoiceType } = {}) => {
                    const params = { apApplyNo: this.currObject.apApplyNo, openInvoiceType: '' };
                    openInvoiceType && (params.openInvoiceType = openInvoiceType);
                    return genExtsysInvoice(params).then((res) => {
                        if (res && +res.code === 0 && +res.data.code === 0) {
                            toQuery.hasInvoice = true;
                            toFn();
                        } else if (res.data.code === '9') {
                        // 打开选择开票方式弹窗
                            this.openInvoiceTypeDialog = true;
                            this.openInvoiceTypeTitle = res.data.errMsg;
                            this.genExtsysInvoiceExecuteFn = genExtsysInvoiceFn;
                        } else {
                            this.$message.warning(res.data.errMsg);
                        }
                    });
                };
                genExtsysInvoiceFn();
            } else {
                toFn();
            }
        },

        // 选择发票标签确认
        handleInvoLabelConfirm({ invoiceLabel }, offDialog) {
            this.invoiceLabelDialogLoading = true;
            relateInfoOfExtsysInvoice({ apApplyNo: this.currObject.apApplyNo }).then((res) => {
                if (res && +res.code === 0) {
                    res.data instanceof Array && res.data.length && (this.currObject = { ...this.currObject, ...res.data[0] });
                }
            }).finally(() => {
                this.goGenerateInvoice(false, invoiceLabel);
                this.invoiceLabelDialogLoading = false;
                offDialog();
            });
        },

        // 选择开票方式确认
        handleOpenInvoiceTypeConfirm({ openInvoiceType }, offDialog) {
            this.openInvoiceTypegLoading = true;
            this.genExtsysInvoiceExecuteFn && this.genExtsysInvoiceExecuteFn({ openInvoiceType }).finally(() => {
                this.openInvoiceTypegLoading = false;
                offDialog();
            });
        },

        // 确认关联发票
        assoInvoiceFn(data) {
        },
        // 确认关联发票
        confirmNoAssoInvoiceDialog({ checkList, onLoading, offLoading }) {
            if (!checkList.length) {
                this.$message.warning('请选择数据');
                return;
            }
            const invoiceJobIds = checkList.map(el => el.jobId);
            onLoading();
            uploadAndSaveInvoice({
                businessId: this.currObject.jobId,
                invoiceJobIds
            }).then(res => {
                if (res && res.code === '0') {
                    this.refreshInvoice();
                    this.$message.success('保存成功');
                }
            }).finally(() => {
                this.openNoAssoInvoiceDialog = false;
                offLoading();
            });
        },
        // 确认关联了智汇票开票的发票
        confirmAssoSmartInvoiceDialog({ checkList }) {
            if (!checkList.length) {
                this.$message.warning('请选择数据');
                return;
            }
            const invoiceNoQueue = [];
            let amtSum = 0;
            checkList.forEach((el) => {
                amtSum += el.amt;
            });
            this.$confirm(`红冲发票累计金额为${amtSum}，请确认是否红冲并提交开票？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.cancelButtonLoading = true;
                        instance.confirmButtonText = '红冲中...';
                        checkList.forEach((el) => {
                            invoiceNoQueue.push(el.invoiceNo);
                        });
                        const params = { invoiceNo: invoiceNoQueue.join(','), jobId: this.currObject.jobId, 'isRedFlush': 'Y' };
                        cancelApplyE(params).then((res) => {
                            if (res && res.code === '0') {
                                this.$message.success('作废成功');
                                this.apApplyListApDetail();
                                this.refreshInvoice();
                            }
                        }).finally(() => {
                            done();
                            instance.confirmButtonText = '确定';
                            instance.confirmButtonLoading = false;
                            instance.cancelButtonLoading = false;
                            this.openAssoSmartInvoiceDialog = false;
                        });
                    } else {
                        done();
                    }
                }
            }).then(() => {

            });
        },

        openMsgConfirmbox(msg = '') {
            return this.$msgbox({
                title: '请确认',
                message: msg,
                type: 'info',
                showCancelButton: true,
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                confirmButtonText: '是',
                cancelButtonText: '否'
            });
        },
        getSelectOptionsByDict(dictData) {
            return Object.keys(dictData).map(key => {
                return { label: dictData[key], value: key };
            });
        },
        remarkStatuSave(flag) {
            this.isSaveChild = flag;
        },
        updateBank(data, tag) {
            if (tag === 'account') {
                this.currObject.accountName = data.bankAccount;
                this.currObject.bankUserName = data.bankAccountName;
                this.currObject.contractNumber = data.ubankno;
                this.currObject.bankName = data.bankName;
            }
            if (tag === 'accept') {
                this.currObject.acceptAccountName = data.bankAccount;
                this.currObject.acceptBankUserName = data.bankAccountName;
                this.currObject.acceptContractNumber = data.ubankno;
                this.currObject.acceptBankName = data.bankName;
            }
        },
        previewClick(row) {
            const onlineViewType = ['pdf'];
            const fileTypeName = row.attachmentUrl.substring(row.attachmentUrl.lastIndexOf('.') + 1, row.attachmentUrl.length).split('?')[0];
            const isWord = onlineViewType.find((type) => type === fileTypeName);
            if (isWord) {
                window.open(row.attachmentUrl, '_blank');
            } else {
                this.titlePicture = '预览';
                this.diaShaow = true;
                this.imgUrl = row.attachmentUrl;
            }
        },
        // 检查系统控制参数“直融宝上线分公司”，分公司在该参数范围内；
        checkSystemParamIncludeFiliale(companyCode) {
            // 获取系统控制参数
            querySysParam().then(res => {
                if (res && res.code === '0') {
                    this.isSystemParamIncludeFiliale = res.data.includes(companyCode);
                }
            });
        },
        handelAdvCollResData(resData) {
            this.advCollChangeStatusName = resData.data &&
                resData.data.length ?
                (resData.data[0].changeStatus || '') : '';
            this.advanceCollectionBtnLoading = false;
        },
        handleStartClose() { this.diaShaow = false; },
        uploadInvoice() {
            this.title = '上传发票';
            this.dialogVisible = true;
        },
        outloadInvoice() {
            const typeArr = ['12', '13', '14', '15', '16', '17'];
            const includeAdd = [];
            this.invoiceLists.forEach(item => {
                if (typeArr.includes(item.invoiceType)) {
                    includeAdd.push(item);
                }
            });
            if (this.currObject.remark) {
                if (includeAdd.length === this.invoiceLists.length) {
                    const data = {
                        jobId: this.currObject.jobId,
                        apApplyNo: this.currObject.apApplyNo
                    };
                    invoiceOperation(data).then(res => {
                        if (res.code === '0') {
                            this.$alert('非纸质发票，无需寄出，单据发票状态更新成功!', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.getApApply();
                                }
                            });
                        }
                    });
                } else {
                    this.title = '发票寄出';
                    this.MalldialogVisible = true;
                }
            } else {
                this.$message.error('备注不能为空，请先填写备注');
            }
        },
        cancelDialogMall() { this.MalldialogVisible = false; },

        checkDataInfo() {
            if (this.currObject.remark) {
                return true;
            } else {
                this.$message.warning('上传发票前，请先录入并保存备注信息');
                return false;
            }
        },

        getInvoiceOperation(data) {
            invoiceOperation(data).then(res => {
                if (res.code === '0') {
                    this.$message.success('发票寄出成功，发票寄出后，请点击“提交付款”按钮');
                    this.getApApply();
                }
                this.MalldialogVisible = false;
            });
        },
        goLists() { this.$router.push({ path: `/bms/settle` }); },
        getApApply() {
            getSettleDetailLists({ apApplyNo: this.currObject.apApplyNo, jobId: this.currObject.jobId }).then(res => {
                if (res && res.code === '0') {
                    this.currObject = res.data.list[0];
                    this.isSmartInvoice = this.currObject && !!this.currObject.eisInvoicing;
                    const { invoiceStatus, status, payStatus } = this.currObject;
                    this.invoiceStatus = invoiceStatus || '';
                    this.status = status || '';
                    this.payStatus = payStatus || '';
                    this.checkSystemParamIncludeFiliale(this.currObject.companyCode);
                    this.transformation(this.currObject);
                    this.showHendle();
                    this.visualization();
                    if (!this.currObject.remark) {
                        this.remarkOK = true;
                    } else {
                        this.remarkOK = false;
                    }
                    this.cancelAmt = parseFloat(this.currObject.fineAfterAmt + this.currObject.chargeoffPreAmt + this.currObject.depositAmt +
                        this.currObject.chargeoffArAmt + this.currObject.preInvoiceAmt).toFixed(2);
                    this.$forceUpdate();
                }
            });
        },
        apApplyListApDetail() {
            getApApplyListApDetail({ apApplyNo: this.currObject.apApplyNo }).then(res => {
                this.billheaderList = res.data;
            });
        },
        async getInvoiceList() {
            await getFillLists({ apApplyNo: this.currObject.apApplyNo }).then(res => {
                if (res && res.code === '0' && res.data && res.data.list) {
                    this.invoiceLists = res.data.list;
                    this.accInvoiceAmt = 0;
                    this.preAmt = 0;
                    this.invoiceLists.forEach(item => {
                        if (item.invoiceSource === '4') {
                            this.preAmt += item.amt;
                        }
                        if (item.invoiceNo.indexOf(INVOICE_OT) === 0) { // 剔除已OT开头得发票
                            return;
                        }
                        this.accInvoiceAmt += item.amt;
                    });
                    this.accInvoiceAmt = parseFloat(this.accInvoiceAmt).toFixed(2);
                    this.isInvoLoad = true;
                }
            });
        },
        updateAnnexesList() {
            this.accessory();
        },
        accessory() {
            getAccessoryList({ businessId: this.currObject.jobId }).then(res => {
                if (res && res.code === '0') {
                    res.data.forEach((item, index) => { item.id = index + 1; });
                    this.accessoryList = res.data;
                }
            });
        },
        visualization() {
            getVisualization({ apApplyNo: this.currObject.apApplyNo }).then(res => {
                if (res && res.code === '0') {
                    const processData = JSON.parse(JSON.stringify(data.process));
                    !this.isApService && (this.process.step = processData.step.filter(item => !item.isApService));
                    res.data.forEach((item, index) => {
                        this.process.step[index].titleName = item.titleName;
                        this.process.step[index].id = item.id;
                        this.process.step[index].carTimes = index !== (this.PROCESS_LAST_STEP - 1) ? item.carTimes : '';
                        // 最后一项时间只显示年月日不显示时分秒的处理
                        if (index === this.PROCESS_LAST_STEP) {
                            this.process.step[index].carTimes = item.carTimes.split(' ')[0];
                        }
                    });
                }
            });
        },
        deleteInvoice(row) {
            this.$confirm('此操作将永久删除当前发票信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = {
                    businessId: this.currObject.jobId,
                    invoiceNo: row.invoiceNo,
                    recVer: this.currObject.recVer
                };
                deleteInvoice(params).then(res => {
                    if (res && res.code === '0') {
                        this.refreshInvoice(); this.$message.success('发票已删除');
                    }
                }).catch(() => {});
            }).catch(() => {});
        },
        // 红冲
        handleRedOffset(row) {
            this.$confirm(`红冲发票累计金额为${row.amt}，请确认是否红冲并提交开票？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.cancelButtonLoading = true;
                        instance.confirmButtonText = '红冲中...';
                        redFlushInvoice({
                            businessId: this.currObject.jobId,
                            invoiceNO: row.invoiceNo,
                            recVer: this.currObject.recVer
                        }).then((res) => {
                            if (res && res.code === '0') {
                                this.$message.success('发票红冲成功');
                                this.refreshInvoice();
                                done();
                            }
                        }).finally(() => {
                            instance.confirmButtonText = '确定';
                            instance.confirmButtonLoading = false;
                            instance.cancelButtonLoading = false;
                        });
                    } else {
                        done();
                    }
                }
            }).then(() => {

            });
        },
        // 重开
        handleReopen(row) {
            this.$confirm(`请确认重开？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.cancelButtonLoading = true;
                        instance.confirmButtonText = '重开中...';
                        reissueInvoice({
                            businessId: this.currObject.jobId,
                            invoiceNO: row.invoiceNo,
                            recVer: this.currObject.recVer
                        }).then((res) => {
                            if (res && res.code === '0') {
                                this.$message.success('发票重开成功');
                                this.refreshInvoice();
                                done();
                            }
                        }).finally(() => {
                            instance.confirmButtonText = '确定';
                            instance.confirmButtonLoading = false;
                            instance.cancelButtonLoading = false;
                        });
                    } else {
                        done();
                    }
                }
            }).then(() => {

            });
        },
        // 网点信息
        getNetworkInfos() {
            getNetworkInfos({ apApplyNo: this.currObject.apApplyNo }).then(res => {
                if (res && res.code === '0') {
                    this.networkInfoLists = this.formatData(res.data.list);
                    if (res.data.list.length !== 0) {
                        this.isNetworkInfos = true;
                    }
                } else {
                    this.$message.error('您输入的结算单暂无网点信息');
                }
                return this.isNetworkInfos;
            }).catch(() => { });
        },
        // 合同列表
        getSuContract() {
            getSuContract({ apApplyNo: this.currObject.apApplyNo }).then(res => {
                if (res && res.code === '0') {
                    const { SYS_SU_CONTRACT_STATUS_SUPP, SYS_SUPPLIER_SERVICES_SUPP } = window.sessionStorage;
                    const contractStatus = SYS_SU_CONTRACT_STATUS_SUPP ? JSON.parse(SYS_SU_CONTRACT_STATUS_SUPP) : {};
                    const contractServ = SYS_SUPPLIER_SERVICES_SUPP ? JSON.parse(SYS_SUPPLIER_SERVICES_SUPP) : {};
                    this.contractDataList = res.data.map(item => {
                        item.contractStatus = contractStatus[item.contractStatus];
                        item.businessTypeSupplier = contractServ[item.businessTypeSupplier];
                        return item;
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
            });
        },

        // 初始化数据字典
        transformation(datas) {
            const { SYS_BMS_AP_PAYMENT_STAT_SUPP, SYS_BMS_AP_APPLY_STATUS_SUPP, SYS_BMS_APPLY_INVOICE_STATUS } = window.sessionStorage;
            this.payStatusName = SYS_BMS_AP_PAYMENT_STAT_SUPP ? JSON.parse(SYS_BMS_AP_PAYMENT_STAT_SUPP)[datas.payStatus] : datas.payStatus;
            this.statusName = SYS_BMS_AP_APPLY_STATUS_SUPP ? JSON.parse(SYS_BMS_AP_APPLY_STATUS_SUPP)[datas.status] : datas.status;
            this.invoiceStatusName = SYS_BMS_APPLY_INVOICE_STATUS ? JSON.parse(SYS_BMS_APPLY_INVOICE_STATUS)[datas.invoiceStatus] : datas.invoiceStatus;
        },
        // 加载标签页
        loadDetails() {
            if (this.$route.query.apApplyNo) {
                this.isLoading = true;
                feeApBillQuery({
                    apApplyNo: this.currObject.apApplyNo,
                    oilCardAmountPaid: this.preAmt
                }).then(res => {
                    if (res && res.code === '0') {
                        const { BID_BUSINESS_TYPE, SRM_BMS_TASK_TYPE } = window.sessionStorage;
                        this.taxRateData = [];
                        this.taxDifference = 0;
                        this.classification = 0;
                        this.taxRateData.totalAmountText = res.data.totalAmount;
                        Object.keys(res.data.taxRateAmountMap).forEach(key => {
                            const keyArr = key.split('_');
                            this.taxRateData.push({ taxRate: keyArr[0], feeTaskTypeText: JSON.parse(BID_BUSINESS_TYPE)[keyArr[1]], value: res.data.taxRateAmountMap[key] });
                        });
                        this.tableDataLists = res.data.feeTaskHeaderList && res.data.feeTaskHeaderList.map(item => {
                            this.taxDifference += item.sumAmt;
                            if (item.feeTaskType === '30') {
                                this.classification += item.sumAmt;
                            }
                            item.businessTypeText = BID_BUSINESS_TYPE ? JSON.parse(BID_BUSINESS_TYPE)[item.businessType] : item.businessType;
                            item.feeTaskTypeText = SRM_BMS_TASK_TYPE ? JSON.parse(SRM_BMS_TASK_TYPE)[item.feeTaskType] : item.feeTaskType;
                            return item;
                        });
                    }
                }).finally(() => {
                    this.isLoading = false;
                });
            }
        },
        // 提交付款
        submitApply() {
            const RegExp = /[%':'"%‘：”“’]/;
            if (RegExp.test(this.currObject.remark)) return;
            if (this.remarkOK) {
                this.$message.warning('请先保存备注信息!');
                return;
            }
            if (!this.$refs.billInfo.apApply.accountName) {
                this.$message.warning('现汇银行账号不能为空!');
                return;
            }

            const submitApplyRequest = () => {
                submitApply({
                    apApplyNo: this.currObject.apApplyNo,
                    jobId: this.currObject.jobId,
                    recVer: this.currObject.recVer
                }).then(res => {
                    if (res && res.code === '0' && res.data.code === '0') {
                        this.$message.success('提交成功');
                        this.refreshInvoice();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            };

            // 【单据来源】为“供应商平台”，且“是否应付账款服务”为否
            if (['50', 50].includes(this.currObject.billSource) && ['0', 0].includes(this.currObject.isApService)) {
                // 自助结算mip流程校验发票开票人和付款单供应商是否一致
                const formData = new FormData();
                formData.append('apApplyNo', this.currObject.apApplyNo);
                checkApplySupIsEqualOpenInvoiceCompany(formData).then(res => {
                    if (res && res.code === '0') {
                        submitApplyRequest();
                    } else {
                        this.openMsgConfirmbox(`${res.msg}`).then(() => {
                            submitApplyRequest();
                        }).catch(() => {
                            // 否
                        });
                    }
                });
                return;
            }
            submitApplyRequest();
        },
        // * 保存
        confirmOk() {
            if (this.$refs.billInfo.apApply.acceptAmt > 0 && (this.$refs.billInfo.apApply.acceptAccountName === undefined || this.$refs.billInfo.apApply.acceptAccountName === '')) {
                this.$message.warning('承兑银行账号不能为空');
                return;
            }
            if (!this.$refs.billInfo.apApply.accountName) {
                this.$message.warning('现汇银行账号不能为空!');
                return;
            }
            if (!this.isSaveChild) {
                saveApply(this.currObject).then(res => {
                    if (res && res.code === '0' && res.data.code === '0') {
                        this.$message.success(this.isSmartInvoice ? '保存生成，请生成/关联发票' : '保存成功，温馨提示：请上传发票后再邮寄发票');
                        this.getApApply();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            }
        },
        // 撤回提交付款
        recallClick() {
            this.loading = true;
            const params = { apApplyNo: this.currObject.apApplyNo, jobId: this.currObject.jobId, recVer: this.currObject.recVer };
            recallApply(params).then(res => {
                if (res && res.code === '0' && res.data.code === '0') {
                    this.$message.success('撤回成功');
                    this.refreshInvoice();
                } else {
                    this.$message.error(res.data.msg);
                }
                this.loading = false;
            });
        },
        /**
         * 发票寄出
         */
        sendOut(callback) {
            const params = {
                deliveryCompany: this.payObj.deliveryCompany,
                deliveryNo: this.deliveryNo,
                jobId: this.currObject.jobId,
                apApplyNo: this.currObject.apApplyNo,
                recVer: this.currObject.recVer
            };
            getInvoiceOperation(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('寄出成功');
                    this.refreshInvoice();
                }
            }).catch(() => { });
        },
        refreshInvoice() {
            this.getApApply();
            this.getInvoiceList();
            this.$refs.advanceCollectionRef.finalizationSuccess();
        },
        // 点击新增
        addInvoiceHandler() {
            this.addDialogVisible = true;
        },
        // 关闭新增发票弹窗
        closeAddDialog() {
            this.addDialogVisible = false;
        },
        // 申请提前收款
        handelAdvanceCollection() {
            this.advanceCollectionBtnLoading = true;
            paymentCheck({
                'apApplyNo': this.currObject.apApplyNo,
                'jobId': this.currObject.jobId
            }).then(res => {
                if (res && res.code === '0') {
                    paymentSubmit({
                        'apApplyNo': this.currObject.apApplyNo
                    }).then(res => {
                        if (res && res.code === '0') {
                            this.$refs.advanceCollectionDialog.handleVisible(true, { ...res.data, 'jobId': this.currObject.jobId, 'apApplyNo': this.currObject.apApplyNo });
                        }
                    });
                }
            }).finally(() => {
                this.advanceCollectionBtnLoading = false;
            });
        }
    },
    mounted() {
        this.load();
        setTimeout(() => {
            this.getInvoiceList();
        }, 1000);
    },
    created() {
        initSessionData(['SYS_BMS_AP_PAYMENT_STAT_SUPP', 'SYS_BMS_APPLY_INVOICE_STATUS', 'SYS_SU_CONTRACT_STATUS_SUPP', 'SYS_SUPPLIER_SERVICES_SUPP',
            'SYS_BMS_AP_APPLY_STATUS_SUPP', 'BID_BUSINESS_TYPE']);
        this.billInfo = data.billInfo;
        this.infoData = data.infoData;
        this.taxRateData = data.taxRateData;
        this.process = JSON.parse(JSON.stringify(data.process));
        this.tableDataItems = data.tableDataItems;
        this.invoiceItems = data.invoiceItems;
        this.invoiceLists = data.invoiceLists;
        this.accessoryItems = data.accessoryItems;
        this.accessoryList = data.accessoryList;
        this.networkInfoItems = data.networkInfoItems;
        this.checkCancelInfoItems = data.checkCancelInfoItems;
        this.contractInfoItems = data.contractInfoItems;
    },
    watch: {
        'payObj.deliveryCompany'(data) {
            if (data === undefined || data === '') {
                this.isInvoiceNo = true;
            } else {
                this.isInvoiceNo = false;
            }
        }
    }
};
</script>
<style lang="less">
@import "../../../styles/common.less";
@import "../../../styles/billDetails.less";
@import "../../../styles/settleDetails.less";
.add-invoice-btn {
    border: 1px solid #ffece3;
    background-color: #fffbf2;
    margin: 4px 0 16px 0;
    height: 28px;
    line-height: 28px;
}
.add-invoice-ico,.red-offset-ico,.reopen-ico {
    display: inline-block;
    cursor: pointer;
    border: none;
    background-color: #fffbf2;
    height: 28px;
    line-height: 0;
    padding: 0 6px;
}
.research-label {
    margin-left: 10px;
    font-size: 14px;
    color: #666;
}
.hintAssoInvoseDialog {
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        text-align: center;
        padding-bottom: 15px;
        .info {
            font-size: 14px;
        }
    }
}
</style>
